module.exports = __webpack_public_path__ + "static/media/white-heart.daf330ed.svg";